import fuzzysort from "fuzzysort";

export const orgListFilter = (
  options: { name?: string; shopId?: string; id?: string }[],
  value: string
) => {
  if (!options) {
    return [];
  }
  if (!value) {
    return options;
  }

  return fuzzysort
    .go(value, options, { keys: ["name", "id", "shopId"] })
    .map((result) => result.obj);
};
